import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPendingContactVerification, useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';
import InlineAlertBanner from './InlineAlertBanner';

const T = {
  fr: {
    phone: (contact) => (
      <>Nouveau numéro <strong>{contact}</strong> en attente de confirmation.</>
    ),
    email: (contact) => (
      <>Nouvelle adresse <strong>{contact}</strong> en attente de confirmation.</>
    ),
    action: 'Confirmer',
  },
  en: {
    phone: (contact) => (
      <>New number <strong>{contact}</strong> pending confirmation.</>
    ),
    email: (contact) => (
      <>New address <strong>{contact}</strong> pending confirmation.</>
    ),
    action: 'Confirm',
  },
  ar: {
    phone: (contact) => (
      <>رقم جديد <strong>{contact}</strong> بانتظار التأكيد.</>
    ),
    email: (contact) => (
      <>بريد جديد <strong>{contact}</strong> بانتظار التأكيد.</>
    ),
    action: 'تأكيد',
  },
};

export default function ContactVerificationBanner({ user }) {
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const { resendVerificationCode } = useAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const pending = getPendingContactVerification(user);

  const handleConfirm = useCallback(async () => {
    if (!pending) return;
    setError(null);
    setLoading(true);
    try {
      const isPhone = pending.contactMode === 'phone';
      await resendVerificationCode({
        email: isPhone ? null : pending.contact,
        phoneNumber: isPhone ? pending.contact : null,
      });
      navigate('/verify', {
        state: {
          contact: pending.contact,
          contactMode: pending.contactMode,
          codeSent: true,
        },
      });
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }, [pending, resendVerificationCode, navigate]);

  if (!pending) return null;

  const t = T[lang] || T.fr;
  const isPhone = pending.contactMode === 'phone';
  const message = isPhone ? t.phone(pending.contact) : t.email(pending.contact);

  return (
    <InlineAlertBanner
      message={message}
      actionLabel={t.action}
      onAction={handleConfirm}
      loading={loading}
      error={error}
    />
  );
}
